/**
 * PrivacySLPrivacyTextView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PrivacySLPrivacyText
 */

import { usePrivacySLPrivacyTextLogic } from '@/hooks/traits/usePrivacySLPrivacyTextLogic';
import type { PrivacySLPrivacyTextConfig } from '@/hooks/traits/usePrivacySLPrivacyTextLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PrivacySLPrivacyView as PrivacySLPrivacyViewEntity } from '@app/shared';
import { Badge } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { MarkdownContent } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface PrivacySLPrivacyTextViewProps {
  config?: Partial<PrivacySLPrivacyTextConfig>;
}

export function PrivacySLPrivacyTextView({ config: propsConfig }: PrivacySLPrivacyTextViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePrivacySLPrivacyTextLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PrivacySLPrivacyView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PrivacySL" trait="PrivacySLPrivacyText">
      {slotWriter['main'] === 'INIT' ? (<Box paddingY="xl" bg={(false) ? "muted" : "transparent"} fullWidth={true} dir="ltr"><Container maxWidth="md" padding="lg" size="md"><Stack gap="md" direction="vertical"><Badge variant="primary" label="" /><Typography content={renderPatternValue(__t("std-almadar-privacy:privacy.heading"))} className={((__t("std-almadar-privacy:privacy.heading") === "")) ? "hidden" : "tracking-tight text-balance"} size="3xl" variant="h1" weight="bold" /><Typography color="muted" variant="caption" className={(true) ? "hidden" : ""} content="" /><MarkdownContent content={String(__t("std-almadar-privacy:privacy.body"))} direction="ltr" /></Stack></Container></Box>) : null}
    </TraitScopeProvider>
  );
}

export default PrivacySLPrivacyTextView;
